import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
    providedIn: 'root'
})
export class CamionChoferService {

    constructor(private gqlclient: GraphQLClient) { }

    obtenerSegunPatente(inputParams, callback: Function) {
        this.gqlclient.query(
            {
                query: gql`
        query ($entidad: camion_choferInputType) {
            camion_chofer {
                obtenerSegunId(entidad: $entidad) {
                    mensajes {
                        codigo
                        contexto
                        texto
                        tipo
                    }
                    respuesta {
                        patente
                        rut_chofer
                    }
                }
            }
        }
        `,
                variables: inputParams,
                fetchPolicy: 'no-cache',
            },
            function (response) {
                const { mensajes, respuesta } = response.data.camion_chofer.obtenerSegunId
                callback({ mensajes, respuesta })
            }
        );
    }
}
